import React, { useState } from 'react';
import { connect } from 'react-redux';
import CardProfile from '../../../components/Profile/Card/';
//import AboutForm from './Forms';
import { Formik } from 'formik';
import { validationContactInfoAbout } from '../../../utils/validations';
import ButtonBase from '../../../components/Buttons/ButtonBase';
import SecondaryButton from '../../../components/Buttons/SecondaryButton';
import { makeStyles } from '@material-ui/styles';
import { Button, Tooltip, ClickAwayListener } from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import ModalShare from '../../../components/Modal/ModalShare';
import './Share.scss';

const useStyles = makeStyles({
  cardHeader: {
    display: 'block',
    paddingBottom: 0,
    fontSize: 22,
    '&:after': {
      content: '""',
      display: 'block',
      margin: '0 auto',
      width: '100%',
      paddingTop: '8px',
      borderBottom: '1px solid #c1c1c1',
    },
  },
  blueText: {
    color: '#10587f',
    fontWeight: 'bold',
    fontSize: 16,
    marginBottom: 8
  },
  blueTextDisabled: {
    color: '#c1c1c1',
    fontWeight: 'bold',
    fontSize: 16,
    marginBottom: 8
  },
  buttonStyle: {
    minWidth: 256
  },
  customTooltip: {
    backgroundColor: '#094565',
    margin: '4px 0 0',
    padding: 8,
    maxWidth: 224,
    lineHeight: 1.2,
  },
  tooltipParagraph: {
    margin: 0,
    fontSize: 14,
    '& b': {
      fontSize: 14,
      fontWeight: 'bold'
    }
  },
});

const Share = ({ authClient, membershipType }) => {
  const { role } = authClient;
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [isOpinion, setIsOpinion] = useState(false);
  const [isSocial, setIsSocial] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpinion = (event) => {
    //setSubmitting(false);
    setOpen(true);
    setIsOpinion(true);
    setIsSocial(false);
  };

  const handleSocial = (event) => {
    //setSubmitting(false);z48
    setOpen(true);
    setIsOpinion(false);
    setIsSocial(true);
  };

  const link = `https://contactaabogado.com/${authClient.role === 'lawyer' ? 'abogado' : 'despacho'}/${authClient.uid}`;

  const [openTooltip1, setOpenTooltip1] = useState(false);
  const handleTooltipClose1 = () => {
    setOpenTooltip1(false);
  };
  const handleTooltipOpen1 = () => {
    setOpenTooltip1(true);
  };

  const [openTooltip2, setOpenTooltip2] = useState(false);
  const handleTooltipClose2 = () => {
    setOpenTooltip2(false);
  };
  const handleTooltipOpen2 = () => {
    setOpenTooltip2(true);
  };

  return (
    <>
    <div className={'share'}>
      <CardProfile
        title={'Compartir'}
        subTitle={authClient && role === 'lawFirm' ?
          'Puedes compartir para que conozcan al despacho y opinen sobre los servicios que ofrecen.' :
          'Puedes compartir para que te conozcan y opinen sobre los servicios que ofreces'
        }
        awardIcon
        status={authClient && authClient.awardAditional.shareProfile ? authClient.awardAditional.shareProfile : false}
      >
        <div className="containerShare">
          <div className={classes.blueText}>
            {authClient && role === 'lawFirm' ?
              'Compartir para que recomienden el despacho' :
              'Compartir para que te recomienden'
            }
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <ButtonBase
              onClick={handleOpinion}
              variant="primaryOutlined"
              buttonStyle={classes.buttonStyle}
            >
              Solicitar recomendación
            </ButtonBase>
            {isMobile === true ?
            <ClickAwayListener onClickAway={handleTooltipClose1}>
              <Tooltip
                PopperProps={{
                  disablePortal: true,
                }}
                onClose={handleTooltipClose1}
                open={openTooltip1}
                disableFocusListener
                disableHoverListener
                disableTouchListener
                classes={{tooltip: classes.customTooltip}}
                title={
                  <p className={classes.tooltipParagraph}>
                    El <b>link proporcionado</b> te servirá para <b>solicitar recomendaciones</b> u opiniones sobre tu trabajo.
                  </p>
                }
                placement='bottom'
              >
                <img
                  src="/img/profile/ayuda.png"
                  alt="ayuda"
                  style={{ marginLeft: 8 }}
                  onClick={handleTooltipOpen1}
                />
              </Tooltip>
            </ClickAwayListener> :
            <Tooltip
              classes={{tooltip: classes.customTooltip}}
              title={
                <p className={classes.tooltipParagraph}>
                  El <b>link proporcionado</b> te servirá para <b>solicitar recomendaciones</b> u opiniones sobre tu trabajo.
                </p>
              }
              placement='bottom'
            >
              <img src="/img/profile/ayuda.png" alt="ayuda" style={{ marginLeft: 8 }} />
            </Tooltip>
            }
          </div>

          <br></br>
          <br></br>

          <div className={classes.blueText}>
            {authClient && role === 'lawFirm' ?
              'Compartir perfil para que conozcan el despacho' :
              'Compartir perfil para que te conozcan'
            }  
          </div>

          <div style={{ display: 'flex', alignItems: 'center' }}>
            <ButtonBase
              onClick={handleSocial}
              variant="primaryOutlined"
              buttonStyle={classes.buttonStyle}
            >
              {authClient && role === 'lawFirm' ?
                'Compartir perfil del despacho' :
                'Compartir mi perfil'
              }
            </ButtonBase>
            {isMobile === true ?
              <ClickAwayListener onClickAway={handleTooltipClose2}>
                <Tooltip
                  PopperProps={{
                    disablePortal: true,
                  }}
                  onClose={handleTooltipClose2}
                  open={openTooltip2}
                  disableFocusListener
                  disableHoverListener
                  disableTouchListener
                  classes={{tooltip: classes.customTooltip}}
                  title={authClient && authClient.role === 'lawFirm' ?
                    <p className={classes.tooltipParagraph}>
                      El <b>link proporcionado</b> te servirá para compartir el perfil del despacho en diferentes <b>redes sociales</b>.
                    </p> :
                    <p className={classes.tooltipParagraph}>
                      El <b>link proporcionado</b> te servirá para compartir tu perfil en diferentes <b>redes sociales</b>.
                    </p>
                  }
                  placement='bottom'
                >
                  <img
                    src="/img/profile/ayuda.png"
                    alt="ayuda"
                    style={{ marginLeft: 8 }}
                    onClick={handleTooltipOpen2}
                  />
                </Tooltip>
              </ClickAwayListener> :
              <Tooltip
                classes={{tooltip: classes.customTooltip}}
                title={authClient && authClient.role === 'lawFirm' ?
                  <p className={classes.tooltipParagraph}>
                    El <b>link proporcionado</b> te servirá para compartir el perfil del despacho en diferentes <b>redes sociales</b>.
                  </p> :
                  <p className={classes.tooltipParagraph}>
                    El <b>link proporcionado</b> te servirá para compartir tu perfil en diferentes <b>redes sociales</b>.
                  </p>
                }
                placement='bottom'
              >
                <img src="/img/profile/ayuda.png" alt="ayuda" style={{ marginLeft: 8 }} />
              </Tooltip>
            }
          </div>
        </div>
      </CardProfile>
    </div>
    
    <ModalShare open={open} link={link} isOpinion={isOpinion} isSocial={isSocial} handleClose={handleClose}/>
    </>
  );
};

const mapStateToProps = state => ({
  authClient: state.authClient,
  membershipType: state.authClient.membership.type
});

export default connect(mapStateToProps)(Share);
